

























import { defineComponent, ref, computed, useContext } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import { getAromaImageUrl } from '~/utils';

export default defineComponent({
  components: {
    AppImage,
  },
  props: {
    text: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    width: {
      type: String,
      default: 'w-80px',
    },
    widthStyle: {
      type: String,
      default: 'w-80px',
    },
  },
  setup() {
    const isVisible = ref(false);
    const speechBubble = ref();
    const { $device } = useContext();

    const positionCorrectionStyle = computed(() => {
      const clientWidth = speechBubble.value?.clientWidth || 0;
      const clientLeft = speechBubble.value?.getBoundingClientRect()?.left;
      const clientRight = speechBubble.value?.getBoundingClientRect()?.right;
      const styleObject = { left: '', right: '' };
      const padding = 16;
      if (!isNaN(clientLeft) && (clientLeft <= padding || clientLeft < clientWidth / 2)) {
        styleObject.left = '0';
      }
      if ((!isNaN(clientRight) && clientRight + padding > window.innerWidth) || clientWidth > window.innerWidth) {
        styleObject.right = '0';
      }
      return styleObject;
    });

    const toggleSpAndTabVisibility = () => {
      if ($device.isDesktop) {
        return;
      }
      isVisible.value = !isVisible.value;
    };

    const togglePcVisibility = (visibility: boolean) => {
      if (!$device.isDesktop) {
        return;
      }
      isVisible.value = visibility;
    };

    return {
      isVisible,
      speechBubble,
      positionCorrectionStyle,
      toggleSpAndTabVisibility,
      togglePcVisibility,
      getAromaImageUrl,
    };
  },
});
